import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultAttributeData = {
  id: 0,
  enabled: true,
  name: ''
};
export const getAttributes = params => request({
  url: '/attributes',
  method: 'get',
  params
});
export const getAttributesTree = data => request({
  url: '/attributes/tree',
  method: 'post',
  data
});
export const getAttributeById = id => request({
  url: `/attributes/${id}`,
  method: 'get'
});
export const updateAttribute = (id, data) => request({
  url: `/attributes/${id}`,
  method: 'patch',
  data
});
export const deleteAttribute = id => request({
  url: `/attributes/${id}`,
  method: 'delete'
});
export const createAttribute = data => request({
  url: '/attributes/',
  method: 'post',
  data
});